// extracted by mini-css-extract-plugin
export var dropdownIcon = "_ri-6";
export var imgContainer = "_ri-3";
export var menuIcon = "_ri-5";
export var pillWrapper = "_ri-2";
export var pillsContainer = "_ri-1";
export var subscriptionCard = "_ri-0";
export var subscriptionLogo = "_ri-4";